import { createContext } from 'react';

interface FileCardContainerContextInterface {
  isEditMode: boolean;
}

export const FileCardContainerContext = createContext<FileCardContainerContextInterface>({ isEditMode: false });
